<!-- eslint-disable -->
<template lang="pug">
    modal-frame(
                :isContinentsModal="true"
                :displayModal="displayModal"
                @close="$emit('close')"
                @open="$emit('open')"
    )
            .continent-picker-body(slot="body")
                    .continent-picker-header
                            .continent-picker-title
                                |   {{ $i18n.t('map.map_continentsModal_continentPicker') }}
                            .continents-list
                                    a.continent-link-eurasia.continent-link(
                                        href="javascript://"
                                        :class="{'is-disabled': availableContinents.indexOf('Eurasia') === -1}"
                                    )
                                        |   {{ $i18n.t('map.map_continentsModal_eurasia') }}
                                    a.continent-link-africa.continent-link(
                                        href="javascript://"
                                        :class="{'is-disabled': availableContinents.indexOf('Africa') === -1}"
                                    )
                                        |   {{ $i18n.t('map.map_continentsModal_africa') }}
                                    a.continent-link-antarctica.continent-link(
                                        href="javascript://"
                                        :class="{'is-disabled': availableContinents.indexOf('Antarctica') === -1}"
                                    )
                                        |   {{ $i18n.t('map.map_continentsModal_antarctica') }}
                                    a.continent-link-australia.continent-link(
                                        href="javascript://"
                                        :class="{'is-disabled': availableContinents.indexOf('Australia') === -1}"
                                    )
                                        |   {{ $i18n.t('map.map_continentsModal_australia') }}
                                    a.continent-link-northamerica.continent-link(
                                        href="javascript://"
                                        :class="{'is-disabled': availableContinents.indexOf('NorthAmerica') === -1}"
                                    )
                                        |   {{ $i18n.t('map.map_continentsModal_northAmerica') }}
                                    a.continent-link-southamerica.continent-link(
                                        href="javascript://"
                                        :class="{'is-disabled': availableContinents.indexOf('SouthAmerica') === -1}"
                                    )
                                        |   {{ $i18n.t('map.map_continentsModal_southAmerica') }}
                                    a.continent-link-space.continent-link(
                                        href="javascript://"
                                        :class="{'is-disabled': availableContinents.indexOf('Space') === -1}"
                                    )
                                        |   {{ $i18n.t('map.map_continentsModal_Space') }}
                    mini-map(
                            :availableContinents="availableContinents"
                            :hoveredContinent="hoveredContinent"
                    )
</template>

<script>
    /*eslint-disable*/
    import ModalFrame from '../modals/map/ModalFrame.vue'
    import MiniMap from './map-assets/MiniMap.vue'

    import continentsList from '../../../config/continentsList.json'

    export default {
        props: {
            continent: String,
            displayModal: Boolean,
            availableContinents: Array
        },
        components: {
            ModalFrame,
            MiniMap
        },
        watch: {
            displayModal (val) {
                if (val) {
                    window.scrollTo(0, 1);
                }
            }
        },
        methods: {
            addScroll () {
                let modal = document.querySelector('.modal-card-body');
                let mc = new Hammer.Manager(modal);
                let Swipe = new Hammer.Swipe({
                    event: 'swipe',
                    pointers: 1,
                    threshold: 5,
                    direction: Hammer.DIRECTION_VERTICAL,
                    velocity: 0.2
                });
                mc.add(Swipe);
                mc.on('swipedown', (e) => {
                    this.scrollTo(modal, 0, 100);
                });
                mc.on('swipeup', (e) => {
                    this.scrollTo(modal, modal.scrollHeight, 100);
                });
            },
            scrollTo (element, to, duration) {
                if (duration <= 0) {
                    return;
                }
                let stepTime = 10;
                let difference = to - element.scrollTop;
                let perTick = difference / duration * stepTime;
                setTimeout(() => {
                    element.scrollTop = element.scrollTop + perTick;
                    if (element.scrollTop === to) {
                        return;
                    }
                    this.scrollTo(element, to, duration - stepTime);
                }, stepTime);
            },
            addContinentsEvents () {
                continentsList.forEach(continent => {
                    let link = document.querySelector('.continent-link-' + continent.toLowerCase());
                    link.onmouseover = () => {
                        this.hoveredContinent = continent;
                    };
                    link.onmouseout = () => {
                        this.hoveredContinent = null;
                    };
                    link.onclick = () => {
                        if (this.availableContinents.indexOf(continent) !== -1) {
                            this.$emit('changeContinent', continent);
                        }
                    };
                    let continentSvg = document.getElementById(continent);
                    continentSvg.onmouseover = () => {
                        let classString = link.getAttribute('class');
                        link.setAttribute('class', classString + ' hovered');
                    };
                    continentSvg.onmouseout = () => {
                        let classString = link.getAttribute('class');
                        link.setAttribute('class', classString.replace(/hovered/g, ''));
                    };
                });
            }
        },
        mounted () {
            this.addScroll();
            this.addContinentsEvents();
        },
        data () {
            return {
                displayContinents: false,
                continentsList,
                hoveredContinent: null
            }
        }
    }
</script>

<style lang="scss">
    .continent-picker-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: scroll;
        @include media ($md) {
            overflow-y: visible;
        }
    }

    .continent-picker-header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-family: Appetite;
    }

    .continent-picker-title {
        margin: 15px 0 5px;
        font-size: 2.5rem;
        font-weight: 500;
        color: #fa8848;
        @media screen and (max-width: 768px) {
            font-size: 2rem;
        }
    }

    .continents-list {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.3rem;
        flex-wrap: wrap;
        padding-bottom: 0.5rem;
        @media screen and (max-width: 768px) {
            padding-bottom: 0;
        }
    }

    .continent-link {
        color: $hsl-color-gray-92;
        padding: 0 .5rem;
        margin-bottom: 5px;

        &.is-disabled {
            color: $hsl-color-gray-52;
        }

        &:hover {
            color: $hsl-color-yellow-66;
        }
    }

    .hovered {
        color: $hsl-color-yellow-66;
    }

</style>